import React from "react";
import { Typography, List, ListItem, ListItemText, Box } from "@mui/material";
import { Link } from "react-router-dom";
import ContentPageLayout, { bodyTextSx, sectionTitleSx } from "../Pages/ContentPageLayout";
import { NAV } from "../Navbar/navbarTheme";
import { termsIntro, termsSections } from "./termsSections";

const listItemSx = {
  padding: 0,
  display: "list-item",
  pl: 2.5,
  mb: 0.5,
};

const bulletListSx = {
  color: NAV.ink,
  mb: 2,
  pl: { xs: 2, sm: 2.5 },
  listStyleType: "disc",
};

const linkSx = {
  color: NAV.navy,
  fontWeight: 600,
  textDecoration: "underline",
};

function TermsBulletList({ items }) {
  if (!items?.length) return null;
  return (
    <List dense sx={bulletListSx}>
      {items.map((item) => (
        <ListItem key={item} sx={listItemSx}>
          <ListItemText
            primary={item}
            primaryTypographyProps={{
              sx: { fontSize: "1rem", lineHeight: 1.65 },
            }}
          />
        </ListItem>
      ))}
    </List>
  );
}

function TermsSectionBlock({ index, section }) {
  const {
    title,
    paragraphs = [],
    bullets,
    bulletsAfter,
    closing = [],
    closing2 = [],
    privacyLink,
    contact,
  } = section;

  return (
    <Box component="section" sx={{ mb: 1 }}>
      <Typography component="h2" sx={sectionTitleSx}>
        {index}. {title}
      </Typography>

      {privacyLink ? (
        <Typography sx={bodyTextSx}>
          We process personal data in accordance with the UK GDPR and Data
          Protection Act 2018. Personal data may be used for account management,
          quotations, order processing, delivery, export documentation, payment
          administration, compliance checks and customer communication. Further
          information is set out in our separate{" "}
          <Box component={Link} to="/PrivacyPolicy" sx={linkSx}>
            Privacy Policy
          </Box>
          .
        </Typography>
      ) : null}

      {paragraphs.map((text) => (
        <Typography key={text} sx={bodyTextSx}>
          {text}
        </Typography>
      ))}

      <TermsBulletList items={bullets} />

      {closing.map((text) => (
        <Typography key={text} sx={bodyTextSx}>
          {text}
        </Typography>
      ))}

      <TermsBulletList items={bulletsAfter} />

      {closing2.map((text) => (
        <Typography key={text} sx={bodyTextSx}>
          {text}
        </Typography>
      ))}

      {contact ? (
        <Box sx={{ ...bodyTextSx, mb: 0 }}>
          <Typography sx={{ ...bodyTextSx, mb: 0.5, fontWeight: 600 }}>
            UK TO MARS LTD
          </Typography>
          <Typography sx={{ ...bodyTextSx, mb: 0 }}>
            15 Little Balmer
            <br />
            Buckingham Industrial Estate
            <br />
            Buckingham
            <br />
            MK18 1TF
            <br />
            United Kingdom
          </Typography>
          <Typography sx={{ ...bodyTextSx, mb: 0, mt: 1.5 }}>
            Email:{" "}
            <Box component="a" href="mailto:admin@uktomars.co.uk" sx={linkSx}>
              admin@uktomars.co.uk
            </Box>
            <br />
            Telephone: +44 1280 733473
            <br />
            WhatsApp: +44 7564 627910
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

const TermsAndConditions = () => (
  <ContentPageLayout
    title="UK TO MARS LTD"
    subtitle={
      <>
        Terms & Conditions
        <br />
        Effective Date: 15 June 2026
      </>
    }
  >
    {termsIntro.map((text) => (
      <Typography key={text} sx={bodyTextSx}>
        {text}
      </Typography>
    ))}

    {termsSections.map((section, index) => (
      <TermsSectionBlock key={section.title} index={index + 1} section={section} />
    ))}
  </ContentPageLayout>
);

export default TermsAndConditions;
